import { render } from "./ProjectReviewComponent.vue?vue&type=template&id=2faf060d&scoped=true&ts=true"
import script from "./ProjectReviewComponent.vue?vue&type=script&lang=ts"
export * from "./ProjectReviewComponent.vue?vue&type=script&lang=ts"

import "./ProjectReviewComponent.vue?vue&type=style&index=0&id=2faf060d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2faf060d"]])

export default __exports__